import { useEffect } from 'react';
import type { PersistentDebugLogger } from '@/hooks/telemetry/use-persistent-debug-logger';
import {
  MobileModalDebugEvent,
  captureMobileModalEnvironment,
} from '@/hooks/telemetry/mobile-modal-debug';

interface UseCstretchmodalEscapeKeyInput {
  canClose: boolean;
  debugContext?: Record<string, unknown>;
  debugLogger: PersistentDebugLogger;
  debugName?: string;
  handleClose: () => void;
  isTop: boolean;
  visible: boolean;
}

export function useCstretchmodalEscapeKey({
  canClose,
  debugContext,
  debugLogger,
  debugName,
  handleClose,
  isTop,
  visible,
}: UseCstretchmodalEscapeKeyInput): void {
  useEffect((): (() => void) | undefined => {
    if (!visible || !canClose) {
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key !== 'Escape') {
        return;
      }

      if (debugName) {
        debugLogger.logEventFlow({
          name: MobileModalDebugEvent.StretchModalEscapeKey,
          payload: {
            debugName,
            isTop,
            debugContext: debugContext ?? null,
            environment: captureMobileModalEnvironment(),
          },
        });
      }
      event.preventDefault();
      handleClose();
    };

    window.addEventListener('keydown', handleKeyDown);

    return (): void => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    canClose,
    debugContext,
    debugLogger,
    debugName,
    handleClose,
    isTop,
    visible,
  ]);
}
